import { render, staticRenderFns } from "./MemoFormComponent.vue?vue&type=template&id=2016a8a6&scoped=true"
import script from "./MemoFormComponent.vue?vue&type=script&lang=js"
export * from "./MemoFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2016a8a6",
  null
  
)

export default component.exports